export default __webpack_public_path__ + "static/media/wallet.29659a61.svg";